import { Modal } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useState } from 'react';

export const useErrorModal = () => {
  const [error, setError] = useState<string | JSX.Element>();
  const renderErrorModal = () => {
    if (!error) {
      return null;
    }

    return (
      <Modal
        centered
        size="lg"
        onClose={() => setError(undefined)}
        opened={Boolean(error)}
        withCloseButton={false}
        padding={0}
      >
        <div className="flex flex-col p-8">
          {/* Icon and Title Section */}
          <div className="flex items-start gap-4 mb-6">
            <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center">
              <IconAlertCircle size={40} className="text-red-500" />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-text-primary mb-4">
                Error
              </h2>
              <div className="text-text-primary">
                {error}
              </div>
            </div>
          </div>

          {/* Button Section */}
          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={() => setError(undefined)}
              className="px-6 py-3 rounded-lg border-2 border-brand-primary text-brand-primary font-semibold hover:bg-brand-primary/5 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  return { setError, renderErrorModal };
};
